import { Navigate, Outlet } from "react-router-dom";
import { useAuthorization } from "./AuthorizationContext";
import { useAuthContext } from "./loginContext";
import { LoadingOverlay } from "@mantine/core";

interface ProtectedRouteProps {
    redirectTo?: string;
}

export const ProtectedRoute = ({ redirectTo = "/" }: ProtectedRouteProps) => {
    const { isAdmin, loading, error } = useAuthorization();
    const { isLoggedIn } = useAuthContext();

    if (loading) {
        return <LoadingOverlay visible={true} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} loaderProps={{ size: "md", type: "dots" }} />;
    }

    if (!isLoggedIn) {
        return <Navigate to={redirectTo} replace />;
    }

    if (error) {
        console.warn("Error loading authorization, redirecting to home:", error);
        return <Navigate to={redirectTo} replace />;
    }

    if (!isAdmin) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};
